import React from 'react';
import PageRouter from './PageRouter';

function App() {
    return (
        <div className="App">
            <PageRouter />
        </div>
    );
}

export default App;
